export enum TprmRequirementObjectType {
    address = 'Address',
    addressV2 = 'AddressV2',
    coverageFieldAddress = 'CoverageFieldAddress',
}
